import { getPostHeaders } from "./request";

async function deleteRequest(url: string): Promise<void> {
  const requestOptions = {
    method: "DELETE",
    headers: await getPostHeaders()
  };

  const response = await fetch(url, requestOptions);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export default deleteRequest;
